export const menuData = [
  {
    categoria: 'Sucos e Acompanhamentos',
    itens: [
      { nome: 'Copo de Suco de Laranja', preco: '12,00' },
      { nome: 'Jarra de Suco de Laranja', preco: '30,00' },
      { nome: 'Copo com Limão e Gelo', preco: '3,00' },
      { nome: 'Suco Prats Integral Laranja 300ml', preco: '12,00' },
      { nome: 'Suco Prats Laranja 900ml', preco: '20,00' },
    ],
  },
  {
    categoria: 'Refrigerantes',
    itens: [
      { nome: 'Sprite 2l', preco: '13,00' },
      { nome: 'Guaraná Antarctica Pet 2l', preco: '15,00' },
      { nome: 'Guaraná Antarctica 1l', preco: '9,00' },
      { nome: 'Coca-Cola 2l', preco: '16,00' },
      { nome: 'Coca-Cola 1,5l', preco: '12,00' },
      { nome: 'Coca-Cola 220ml', preco: '4,00' },
      { nome: 'Coca-Cola 310ml', preco: '5,50' },
      { nome: 'Coca-Cola Zero 310ml', preco: '5,50' },
      { nome: 'Coca-Cola 500ml', preco: '7,00' },
      { nome: 'Coca-Cola 600ml', preco: '8,00' },
      { nome: 'Coca-Cola com Café 220ml', preco: '4,00' },
      { nome: 'Sprite 310ml', preco: '5,00' },
      { nome: 'Fanta Uva 310ml', preco: '5,00' },
      { nome: 'Fanta Guaraná 310ml', preco: '5,00' },
      { nome: 'Fanta Laranja 310ml', preco: '5,00' },
      { nome: 'Fanta Laranja 500ml', preco: '7,00' },
      { nome: 'Fanta Laranja ou Uva 2l', preco: '13,00' },
      { nome: 'Guaraná Antarctica 269ml', preco: '4,50' },
      { nome: 'Guaraná Antarctica 600ml', preco: '8,00' },
      { nome: 'Guaraná Antarctica 1L', preco: '9,00' },
      { nome: 'Kuat 310ml', preco: '5,00' },
      { nome: 'Kuat 2L', preco: '13,00' },
      { nome: 'Kapo 200ml (Laranja, Morango, Uva ou Maracujá)', preco: '5,00' },
      { nome: 'Schweppes Citrus 310ml', preco: '6,00' },
      {
        nome: 'Suco del valle lata 290ml pessego, uva e maracujá',
        preco: '6,00',
      },
    ],
  },
  {
    categoria: 'Águas e Bebidas Leves',
    itens: [
      { nome: 'Água Mineral Puríssima s/ Gás 497ml', preco: '4,50' },
      { nome: 'Água Mineral Puríssima c/ Gás 500ml', preco: '5,00' },
      { nome: 'Água Mineral Puríssima s/ Gás 1,5l', preco: '6,00' },
      { nome: 'Água Tônica Antarctica 350ml', preco: '8,00' },
      { nome: 'Água Tônica Antarctica Zero 350ml', preco: '8,00' },
      { nome: 'Agua tonica schweppes 310ml', preco: '6,00' },
      { nome: 'H2O Limão / Limoneto 500ml', preco: '10,00' },
      { nome: 'Água de Coco - Kero Coco 330ml', preco: '8,00' },
      { nome: 'Agua de coco kero coco 200ml', preco: '5,00' },
      {
        nome: 'Suplemento vitaminico legger 520ml limão, citrus e açaí',
        preco: '5,00',
      },
    ],
  },
  {
    categoria: 'Gelo',
    itens: [
      { nome: 'Gelo Cubo Grande', preco: '10,00' },
      { nome: 'Gelo Cubo Pequeno', preco: '5,00' },
    ],
  },
];
